/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CrawlerResult } from './crawler-result';
import { Email } from './email';
import { WebsitePromotion } from './website-promotion';
import { WebsiteType } from './website-type';
import { Article } from './article';
import { DirectoryEntry } from './directory-entry';


export interface Website { 
    clientId?: string;
    websiteId?: string;
    websitePublished?: boolean;
    userId?: string;
    efan?: string;
    active?: boolean;
    websiteState?: Website.WebsiteStateEnum;
    primaryDomainName?: string;
    emails?: Array<Email>;
    articles?: Array<Article>;
    promotions?: Array<WebsitePromotion>;
    directoryEntry?: DirectoryEntry;
    crawlerResults?: Array<CrawlerResult>;
    siteTitle?: string;
    siteTheme?: string;
    lastPublishedDate?: string;
    websiteType?: WebsiteType;
}
export namespace Website {
    export const WebsiteStateEnum = {
        New: 'New',
        InDevelopment: 'In development',
        Published: 'Published',
        Unpublished: 'Unpublished',
        Live: 'Live',
        Canceled: 'Canceled'
    } as const;
    export type WebsiteStateEnum = typeof WebsiteStateEnum[keyof typeof WebsiteStateEnum];
}


